import * as React from "react";
import { default as InputEditor } from "./InputEditor";

export const CatchEditor: React.FunctionComponent<CatchProps> = (props) => {
    return (<div>
        <InputEditor name="expression" label={FRENDS.Localizations.Expression} elementId={props.id} value={props.existingParameters["expression"]} />
    </div>
    );
};

interface CatchProps {
    id: string;
    existingParameters: any;
}
